import React, { useEffect } from "react";
import { CreditState } from "../../stores/credit/credit-state.interface";
import { formatNumberWithSpaces } from "../../utils";
import { useCreditDispatch } from "../../stores/credit/credit.store";
import { fetchTotalThunk } from "../../stores/credit/thunks/fetch-total.thunk";
import { useCreditSelector } from "../../stores/product/product.store";

export const Total = () => {
    const total = useCreditSelector((state: CreditState) => state.total);
    const translateText = useCreditSelector((state: CreditState) => state.text);
    const month = useCreditSelector((state: CreditState) => state.selectMonth);
    const selectedShipping = useCreditSelector((state: CreditState) => state.shipping.selectShippingMethod);
    const dispatch = useCreditDispatch();
    
    useEffect(() => {
          dispatch(fetchTotalThunk());
    }, [dispatch]);
    
    return (
        <>
            <div className="border-b border-medium-gray pb-4 mb-4">
                <div className="flex items-center justify-between mb-2">
                    <p>{ translateText.total }</p>
                    <p>{ formatNumberWithSpaces(total.total) } { translateText.currency }</p>
                </div>

                {total.discount > 0 && (
                    <div className="flex items-center justify-between mb-2">
                        <p>{ translateText.discount }</p>
                        <p className="text-red-500">- { formatNumberWithSpaces(total.discount) } { translateText.currency }</p>
                    </div>
                )}

                { total.extraTotal > 0 && <div className="flex items-center justify-between mb-2">
                    <p>{ translateText.extra }</p>
                    <p>{ formatNumberWithSpaces(total.extraTotal) } { translateText.currency }</p>
                </div> }
            </div>
            <div className="border-b border-medium-gray pb-4 mb-4">
                <div className="flex items-center justify-between">
                    <p className="font-semibold">{ translateText.pay }:</p>
                    <p className="font-semibold">{ formatNumberWithSpaces(total.creditTotal) } { translateText.currency } / { month?.monthText }</p>
                </div>
            </div>
            <div>
                <div className="flex items-center justify-between mb-2">
                    { selectedShipping?.code === '_RR_' ? <p>{ translateText.ridicare }</p> :
                        <p>{ translateText.shipping }{ total.shippingTotal > 0 && ` (${ translateText.receipt })` }</p> }
                    <p>{ formatNumberWithSpaces(total.shippingTotal) } { translateText.currency }</p>
                </div>
            </div>
        </>
    )
}